import { am } from './utils';

import httpClient from '@/utils/httpClient';
import logger from '@/utils/logger';

export const INITIALIZE = am('INITIALIZE');
export const CONFIGURE = am('CONFIGURE');
export const GET_ALL_PROVIDERS = am('GET_ALL_PROVIDERS');

export const state = {
  isGetRequestPending: false,
  isGetRequestFailed: false,

  isGetAllProvidersRequestPending: false,
  isGetAllProvidersRequestFailed: false,

  isUpdateRequestPending: false,
  isUpdateRequestFailed: false,

  providers: null,
  extendedProviders: null
};

const getters = {};

export const actions = {
  async initialize({ commit }) {
    commit(INITIALIZE.STARTED);
    try {
      commit(INITIALIZE.COMPLETED, {
        providers: await httpClient.get(`/api/auth/v2`)
      });
    } catch (e) {
      logger.error(e);
      commit(INITIALIZE.FAILED);
      throw e;
    }
  },
  async getAllProviders({ commit }) {
    commit(GET_ALL_PROVIDERS.STARTED);
    try {
      commit(GET_ALL_PROVIDERS.COMPLETED, {
        extendedProviders: await httpClient.get(`/api/auth/v2?showAll=true`)
      });
    } catch (e) {
      logger.error(e);
      commit(GET_ALL_PROVIDERS.FAILED);
      throw e;
    }
  },
  async configure({ commit }, { collection }) {
    commit(CONFIGURE.STARTED);
    try {
      commit(CONFIGURE.COMPLETED, {
        providers: await httpClient.post(`/api/auth/`, collection)
      });
    } catch (e) {
      logger.error(e);
      commit(CONFIGURE.FAILED);
      throw e;
    }
  }
};

export const mutations = {
  [INITIALIZE.STARTED](state) {
    state.isGetRequestPending = true;
    state.isGetRequestFailed = false;
    state.providers = [];
  },
  [INITIALIZE.FAILED](state) {
    state.isGetRequestPending = false;
    state.isGetRequestFailed = true;
  },
  [INITIALIZE.COMPLETED](state, { providers }) {
    state.isGetRequestPending = false;
    state.providers = providers;
  },
  [GET_ALL_PROVIDERS.STARTED](state) {
    state.isGetAllProvidersRequestPending = true;
    state.isGetAllProvidersRequestFailed = false;
    state.extendedProviders = [];
  },
  [GET_ALL_PROVIDERS.FAILED](state) {
    state.isGetAllProvidersRequestPending = false;
    state.isGetAllProvidersRequestFailed = true;
  },
  [GET_ALL_PROVIDERS.COMPLETED](state, { extendedProviders }) {
    state.isGetAllProvidersRequestPending = false;
    state.extendedProviders = extendedProviders;
  },
  [CONFIGURE.STARTED](state) {
    state.isUpdateRequestPending = true;
    state.isUpdateRequestFailed = false;
  },
  [CONFIGURE.FAILED](state) {
    state.isUpdateRequestPending = false;
    state.isUpdateRequestFailed = true;
  },
  [CONFIGURE.COMPLETED](state, { providers }) {
    state.isUpdateRequestPending = false;
    state.providers = providers;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
